import type { IFilter } from "../models/Filter";
import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/prt/warehouse", { offset, filter });
};

export const create = async (data: Record<string, JSONValue>) => {
  return httpRequest.post("/prt/warehouse", data);
};

export const update = async (id: string, data: Record<string, JSONValue>) => {
  return httpRequest.put(`/prt/warehouse/${id}`, data);
};

export const del = async (id: string) => {
  return httpRequest.del(`/prt/warehouse/${id}`);
};

export const get = async (id: string) => {
  return httpRequest.get(`/prt/warehouse/${id}`);
};

export const activate = async (id: string) => {
  return httpRequest.put(`/prt/warehouse/${id}/activate`)
}